import { NgModule } from '@angular/core';
// import { NkCountdownComponent } from './countdown.component';

@NgModule({
  // declarations: [NkCountdownComponent],
  // exports: [NkCountdownComponent],
})
export class NkCountdownModule {}
